import React, { Fragment } from 'react'
import { Badge, ButtonGroup, Card, CardBody, Col, Container, FormGroup, Input, Label, CardHeader, Row, Button } from 'reactstrap'
import { useViewInvoice } from '../../hooks/invoice/useViewInvoice';
import { ModalCancelInvoice } from '../../components/Invoice/ModalCancelInvoice';
import { ModalCancelPreInvoice } from '../../components/Invoice/ModalCancelPreInvoice';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';






export const IndexViewInvoice = () => {

    const {
        listbranch,
        //#region RETURN GLOBAL VARIABLES
        loading, method,
        //#endregion

        //#region MODALS
        modalTitle, modalCancellation, toggleModalCancellation,
        //#endregion

        //#region RETURN VIEW INVOICE
        // RETURN MODELS
        informationInvoice, ListInvoices, ListTypeCancellations,

        id_invoice, code_type_cancellation, code_reference_value, is_general_public,

        handleInputChange,

        //RETURN FILTERS
        iTypeDocument, iTypePayMethod, iDateIni, iDateEnd, iBranch,

        handleInputChangeFilters,

        //RETURN HANDLE METHODS
        SaveCancellationInvoice,
        handleFilters,

        //RETURN PAGINATION
        actualPage, goToPage,
        totalRecords, isgeneral_public,

        // ? CONFIGURATION PRE INVOICE
        preInvoice, tooglePreInvoice, modalPre, saveCancelInvoice,

        // ? CONFIGURATION DATATABLE
        fechaFolioTag, receptorInvoice, typeDocumentTag, actionBodyTemplate, actionPayed, actionIsEnvelopeOpen, actionDownloadPdf,
        actionDownloadXml, actionDownloadSupport, actionStatusInvoice, actionInvoiceOptions, dataLoading,
        iFolio, iRfc, allBranch, handleTypeCompany, resultCount,
        handleInputChangeFilters2, loadingReport, downdloadExcel,
        message, handleClosedMessage,
        _url_helen,
        insan, isGeneral


        //#endregion 



    } = useViewInvoice();


    // ? CONFIGURATION DATATABLE
    const headerStyle =
    {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle =
    {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
    };

    const centerStyle =
    {
        ...cellStyle,
        textAlign: "center",
        zIndex: 2, border: "1px solid #cccccc9c",
        borderCollapse: "collapse"
    };

    const rowsPerPage = 10




    return (


        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <div style={{ paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left", textAlign: "center", height: "20%" }}>
                <Card style={{
                    marginBottom: '15px',
                    background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}>
                    <CardBody style={{ padding: '18px 25px' }}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <div style={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: '15px'
                                }}>
                                    <img alt="flask" className="img-fluid text-info mr-2" src={require("../../assets/images/laboratory-External/cash-money.svg")} style={{ width: "60px", height: "60px" }} />
                                </div>
                                <div>
                                    <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '20px', textAlign: "justify" }}>
                                        Facturas emitidas
                                    </h4>
                                    <small style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '13px' }}>
                                        <i className="fa fa-info-circle mr-1"></i>
                                        Gestión de facturas generadas  en el sistema.
                                    </small>
                                </div>
                            </div>

                        </div>
                    </CardBody>
                </Card>
                {
                    // *REPORT
                }
                <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "1px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "113%", transformOrigin: "top left", textAlign: "center", height: "95%" }}>
                    <Col sm="12" className='pt-3'>
                        <Row>
                            <Col sm="2" className='p-l-0 p-r-0' style={{ textAlign: "left" }}>
                                <Card style={{
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    border: 'none',
                                    height: '100%',
                                    borderRadius: '12px'
                                }}>
                                    <CardHeader style={{
                                        background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                        color: 'white',
                                        padding: '15px',
                                        borderRadius: '12px 12px 0 0'
                                    }}>
                                        <h6 className="mb-0" style={{ fontWeight: 700, fontSize: '15px' }}>
                                            <i className="fa fa-filter mr-2"></i>Filtros de Búsqueda
                                        </h6>
                                    </CardHeader>
                                    <CardBody style={{ padding: '20px' }}>
                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-alt mr-2" style={{ color: '#007bff' }}></i>Fecha de inicio
                                            </Label>
                                            <Input type='date' value={iDateIni} name='iDateIni' onChange={handleInputChangeFilters} className='form-control form-control-sm input-air-primary b-r-9' placeholder='YYYY-MM-DD' />

                                        </FormGroup>
                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Fecha de cierre
                                            </Label>
                                            <Input type='date' value={iDateEnd} name="iDateEnd" onChange={handleInputChangeFilters} className='form-control form-control-sm input-air-primary b-r-9' placeholder='YYYY-MM-DD' />

                                        </FormGroup>
                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Sucursal
                                            </Label>
                                            <Input
                                                type='select'
                                                value={iBranch}
                                                name='iBranch'
                                                onChange={(e) => handleInputChangeFilters2(e)}
                                                className='form-control form-control-sm input-air-primary b-r-9'
                                                placeholder='Sucursal'
                                            >
                                                <option value="0">Selecciona una opción</option>
                                                <option value="0">Todas las sucursales</option>
                                                {listbranch.length > 0 && listbranch.map((s, key) => (
                                                    <option key={key} value={s.id_branch}>
                                                        {s.label}
                                                    </option>
                                                ))}
                                            </Input>
                                        </FormGroup>


                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Tipo de comprobante
                                            </Label>
                                            <Input type="select" value={iTypeDocument} name='iTypeDocument' onChange={handleInputChangeFilters} className='form-control form-control-sm input-air-primary b-r-9' placeholder='Tipo de comprobante'>
                                                <option value="0">Selecciona una opción</option>
                                                <option value="I">Ingreso (Factura)</option>
                                                <option value="E">Egreso (Nota de crédito)</option>
                                                <option value="P">Pago (Complemento de pago)</option>
                                            </Input>
                                        </FormGroup>

                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Método de pago
                                            </Label>
                                            <Input type='select' value={iTypePayMethod} name='iTypePayMethod' onChange={handleInputChangeFilters} className='form-control form-control-sm input-air-primary b-r-9' placeholder='Método de pago'>
                                                <option value="0">Selecciona una opción</option>
                                                <option value="PUE">PUE</option>
                                                <option value="PPD">PPD</option>
                                            </Input>
                                        </FormGroup>

                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Público Genral
                                            </Label>
                                            <Input type="select" value={isgeneral_public} name='isgeneral_public' onChange={handleInputChangeFilters} className='form-control form-control-sm input-air-primary b-r-9' placeholder='Tipo de comprobante'>
                                                <option value="0">Selecciona una opción</option>
                                                <option value="true">Factura Global</option>
                                            </Input>
                                        </FormGroup>

                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>RFC
                                            </Label>
                                            <Input type='text' value={iRfc} name="iRfc" onChange={handleInputChangeFilters} className='form-control form-control-sm input-air-primary b-r-9' placeholder='RFC - Razón social' />

                                        </FormGroup>

                                        <FormGroup>
                                            <Label className='f-w-600 label-report'>
                                                <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Folio
                                            </Label>
                                            <Input type='text' value={iFolio} name='iFolio' onChange={handleInputChangeFilters} className='form-control form-control-sm input-air-primary b-r-9' placeholder='Folio' />

                                        </FormGroup>

                                        <br />
                                        <b>Acciones</b>
                                        <br /><br />



                                        <Button
                                            onClick={() => handleFilters()}

                                            color="primary"
                                            block
                                            outline
                                            className="mb-3"
                                            disabled={dataLoading}
                                            style={{
                                                borderRadius: '10px',
                                                padding: '6px',
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                borderWidth: '2px'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                        >
                                            {!dataLoading && <>

                                                <i className="pi pi-search" />&nbsp;
                                                Buscar
                                            </>

                                            }
                                            {dataLoading ? (
                                                <>
                                                    <i className="pi pi-spin pi-spinner" style={{ fontSize: "0.8rem" }} /> &nbsp;
                                                    Buscando...
                                                </>
                                            ) : null}
                                        </Button>



                                        <Button
                                            color="success"

                                            block
                                            style={{
                                                borderRadius: '10px',
                                                padding: '6px',
                                                fontSize: '13px',
                                                fontWeight: 600,
                                                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                                transition: 'all 0.3s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                            title="Descargar reporte"
                                            disabled={loadingReport}
                                            onClick={() => downdloadExcel()}
                                        >
                                            {!loadingReport && <>
                                                <i className="pi pi-file-excel" style={{ fontSize: "1rem" }} />
                                                Descargar
                                            </>

                                            }
                                            {loadingReport ? (
                                                <>
                                                    <i className="pi pi-spin pi-spinner" style={{ fontSize: "0.8rem" }} />
                                                    Descargando...
                                                </>
                                            ) : null}
                                        </Button>



                                    </CardBody>


                                </Card>
                            </Col>

                            <Col sm="10">

                                <div className="card-container-discount">
                                    <Col sm="12">

                                        <DataTable
                                            value={ListInvoices}
                                            loading={dataLoading}
                                            lazy
                                            paginator
                                            first={(actualPage - 1) * rowsPerPage}
                                            rows={rowsPerPage}
                                            totalRecords={totalRecords}
                                            onPage={(e) => goToPage(e.page + 1)}
                                            className="data-table p-datatable-striped p-datatable-sm"
                                            responsiveLayout="scroll"
                                            emptyMessage={
                                                <div className="text-center">
                                                    <img
                                                        src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                        style={{ width: "32%" }}
                                                        alt="Sin resultados"
                                                    />
                                                    <br />
                                                    <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>No se encontraron resultados.</p>
                                                </div>
                                            }
                                        >
                                            <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                            <Column
                                                header="Serie/Folio"
                                                body={(row) => fechaFolioTag(row)}
                                                headerStyle={headerStyle}
                                                style={centerStyle}
                                            />
                                            <Column
                                                header="Receptor"
                                                body={(row) => receptorInvoice(row)}
                                                headerStyle={headerStyle}
                                                style={centerStyle}
                                            />
                                            <Column field="uuid" header="UUID" headerStyle={headerStyle} style={centerStyle} />
                                            <Column field="dateCreated" header="Fecha" headerStyle={headerStyle} style={centerStyle} />
                                            <Column field="codeCoin" header="Moneda" headerStyle={headerStyle} style={centerStyle} />
                                            <Column field="total" header="Monto" headerStyle={headerStyle} style={centerStyle} />
                                            <Column
                                                header="Tipo"
                                                body={(row) => typeDocumentTag(row)}
                                                headerStyle={headerStyle}
                                                style={centerStyle}
                                            />
                                            <Column
                                                header={<i className="icofont icofont-send-mail f-24 text-warning"></i>}
                                                body={(row) => actionBodyTemplate(row)}
                                                headerStyle={headerStyle}
                                                style={centerStyle}
                                            />
                                            <Column
                                                header={<i className="icofont icofont-coins f-18 text-success"></i>}
                                                body={(row) => actionPayed(row)}
                                                headerStyle={headerStyle}
                                                style={centerStyle}
                                            />
                                            <Column
                                                header={<i className="icofont icofont-envelope-open f-18 text-info"></i>}
                                                body={(row) => actionIsEnvelopeOpen(row)}
                                                headerStyle={headerStyle}
                                                style={centerStyle}
                                            />

                                            <Column
                                                header={<i className="icofont icofont-file-pdf f-18 text-info"></i>}
                                                body={(row) => actionDownloadPdf(row)}
                                                headerStyle={headerStyle}
                                                style={centerStyle}
                                            />
                                            <Column
                                                header={<i className="fa fa-file-code-o f-18 text-info"></i>}
                                                body={(rowData) => actionDownloadXml(rowData)}
                                                style={centerStyle}
                                                headerStyle={headerStyle}

                                            />
                                            <Column
                                                header={<i className="fa fa-file-text f-18" style={{ color: "#f73d6d" }}></i>}
                                                body={(rowData) => actionDownloadSupport(rowData)}
                                                style={centerStyle}
                                                headerStyle={headerStyle}

                                            />
                                            <Column
                                                header="Estado"
                                                body={(rowData) => actionStatusInvoice(rowData)}
                                                style={centerStyle}
                                                headerStyle={headerStyle}

                                            />
                                            <Column
                                                header="Acciones"
                                                body={(rowData) =>
                                                    actionInvoiceOptions(rowData, rowData.isGeneralPublic)
                                                }
                                                style={{
                                                    ...centerStyle,
                                                    position: "relative",
                                                    zIndex: 9999,
                                                    overflow: "visible"
                                                }}
                                                headerStyle={{
                                                    ...headerStyle,
                                                    position: "relative",
                                                    zIndex: 10000
                                                }}
                                            />
                                        </DataTable>
                                    </Col>
                                </div>
                            </Col>

                        </Row>
                    </Col>
                </Card>
            </div >

            <ModalCancelInvoice
                {
                ...{
                    modalTitle, modalCancellation, toggleModalCancellation,
                    loading, method,

                    informationInvoice, ListTypeCancellations,
                    id_invoice, code_type_cancellation, code_reference_value, is_general_public,
                    handleInputChange, SaveCancellationInvoice,
                    message, handleClosedMessage,
                    _url_helen, insan, isGeneral

                }
                }
            />
            <ModalCancelPreInvoice
                {
                ...{
                    preInvoice, tooglePreInvoice, modalPre, saveCancelInvoice
                }
                }
            />
        </div >





    )
}